export enum ContestTypeEnum {
  Points = 1,
  Coins,
  Givs,
  Cash,
  RookieKing,
}

// 1 积分活动 2硬币活动 3活动金币活动 4现金活动
export const contestTypeMap = new Map([
  [ContestTypeEnum.Givs, '活动金币活动'], // 3
  // [ContestTypeEnum.Coins, '充值金币活动'], //2
  [ContestTypeEnum.Points, '积分活动'], // 1
  [ContestTypeEnum.Cash, '现金活动'], // 4
  [ContestTypeEnum.RookieKing, '新人王'], // 5
]);

export const contestTypeMapColumn = new Map([
  [ContestTypeEnum.Givs, '活动金币活动'],
  [ContestTypeEnum.Coins, '充值金币活动'],
  [ContestTypeEnum.Points, '积分活动'],
  [ContestTypeEnum.Cash, '现金活动'],
  [ContestTypeEnum.RookieKing, '新人王'],
]);
